import { render } from "./PeriodicityDialog.vue?vue&type=template&id=7d8ca388&scoped=true"
import script from "./PeriodicityDialog.vue?vue&type=script&lang=js"
export * from "./PeriodicityDialog.vue?vue&type=script&lang=js"

import "./PeriodicityDialog.vue?vue&type=style&index=0&id=7d8ca388&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8ca388"]])

export default __exports__